import type { NodeType } from "@tiptap/pm/model";
import { combineTransactionSteps, findChildrenInRange, getChangedRanges } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";

export interface PreventNodeMarksOptions {
  type: NodeType;
}

// Stops all marks from being added to the Node
// Currently required for inline nodes because yjs doesn't support marks on non-text nodes
// See: https://github.com/yjs/y-prosemirror/issues/47
export function preventNodeMarks(options: PreventNodeMarksOptions) {
  return new Plugin({
    key: new PluginKey("preventNodeMarks"),
    appendTransaction(transactions, oldState, state) {
      const docChanges = transactions.some(transaction => transaction.docChanged) && !oldState.doc.eq(state.doc);
      if (!docChanges) return;

      const { tr } = state;
      const transform = combineTransactionSteps(oldState.doc, [...transactions]);
      const changes = getChangedRanges(transform);
      if (!changes.length) return;

      for (const change of changes) {
        const { newRange } = change;
        const marksInChangedRanges = findChildrenInRange(
          state.doc,
          newRange,
          node => {
            return node.type.name === options.type.name && node.marks.length !== 0;
          },
        );

        for (const marksInChangedRange of marksInChangedRanges) {
          const { node, pos } = marksInChangedRange;
          for (const mark of node.marks) {
            tr.removeNodeMark(pos, mark);
          }
        }
      }

      if (!tr.steps.length) {
        return;
      }

      return tr;
    },
  });
}
